import type { QuestionnaireQuestion } from '../../../infrastructure/QuestionnaireClient';
import { questionTypeUsesOptions } from '../utils/questionTypes';

interface SurveyPreviewProps {
  questions: QuestionnaireQuestion[];
}

const questionLabel = (question: QuestionnaireQuestion, index: number): string => {
  return question.label?.trim() || `Question ${index + 1}`;
};

export function SurveyPreview({ questions }: SurveyPreviewProps) {
  return (
    <section className="border rounded p-3 bg-light h-100" role="region" aria-label="Survey Preview">
      <h3 className="h6 mb-3">Survey Preview</h3>
      <div className="d-grid gap-3">
        {questions.map((question, index) => {
          const type = question.type ?? 'single_select';
          const inputType = type === 'multi_select' ? 'checkbox' : 'radio';
          const options = questionTypeUsesOptions(type) ? question.options ?? [] : [];

          return (
            <div className="bg-white border rounded p-3" key={`${question.questionId}-${index}`}>
              <div className="fw-semibold mb-2">{questionLabel(question, index)}</div>
              {questionTypeUsesOptions(type) && (
                <div className="d-grid gap-2">
                  {options.length > 0 ? (
                    options.map((option, optionIndex) => (
                      <label className="d-flex align-items-center gap-2 mb-0" key={`${option.value}-${optionIndex}`}>
                        <input type={inputType} disabled />
                        <span>{option.label || option.value || `Option ${optionIndex + 1}`}</span>
                      </label>
                    ))
                  ) : (
                    <span className="text-muted small">No options configured</span>
                  )}
                </div>
              )}
              {type === 'rating' && (
                <div className="d-flex gap-2">
                  {[1, 2, 3, 4, 5].map((rating) => (
                    <button
                      key={rating}
                      type="button"
                      className="btn btn-outline-secondary btn-sm"
                      disabled
                      aria-label={`Rating ${rating}`}
                    >
                      {rating}
                    </button>
                  ))}
                </div>
              )}
              {type === 'free_text' && (
                <textarea className="form-control" rows={3} placeholder="Free text response" disabled />
              )}
              {type === 'email' && <input className="form-control" type="email" placeholder="name@example.com" disabled />}
            </div>
          );
        })}
      </div>
    </section>
  );
}
